import { com, kotlin } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import Patch from './Patch'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import PatchEntitiesRequest = com.eidu.sharedlib.entity.api.entities.PatchEntitiesRequest
import EntityId = com.eidu.sharedlib.entity.EntityId
import KtMap = kotlin.collections.KtMap
import PatchEntityRequest = com.eidu.sharedlib.entity.api.entities.PatchEntityRequest

type PatchEntitiesParameters = {
  patchesByEntityId: Map<EntityId, Patch>
}

const patchEntities = async ({ patchesByEntityId }: PatchEntitiesParameters) => {
  const authContext = await requireAuthContext()
  const response = await fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/entities`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: serializeToJsonString(
      new PatchEntitiesRequest(
        KtMap.fromJsMap(
          new Map(
            [...patchesByEntityId].map(([id, patch]) => [
              id,
              new PatchEntityRequest(
                patch.valuesToUpdateByFieldId
                  ? KtMap.fromJsMap(patch.valuesToUpdateByFieldId)
                  : KtMap.fromJsMap(new Map()),
                patch.linksToUpdate ? KtMap.fromJsMap(patch.linksToUpdate) : KtMap.fromJsMap(new Map())
              ),
            ])
          )
        )
      )
    ),
    method: 'PATCH',
  })
  if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from patchEntities endpoint`)
}

export default patchEntities
